import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { GetOrder, checkSession, CancelOrderItem } from './module';

const initialState = {
    orderDetails: null,
    tenantList: null,
    mySession: null,
    file: {
        name: null,
        url: null
    },
    payCount: 0,
    status: "idle",
    ActionStatus: "",
    errorMessage: ""
};

export const GetOrderAsync = createAsyncThunk(
    'requestDetails/GetOrder',
    async (data, ThunkAPI) => {
        const response = await GetOrder({ ...data, AttachmentChecking: true });
        return response;
    }
);

export const checkLoginAsync = createAsyncThunk(
    'requestDetails/checkLogin',
    async (index, ThunkAPI) => {
        const response = await checkSession();

        return response;
    }
);

export const checkSessionAsync = createAsyncThunk(
    'requestDetails/checkSession',
    async (index, ThunkAPI) => {
        const response = await checkSession();
        const resultPromise = Promise.resolve(response);
        resultPromise.then((data, index) => {
            if (data && data.Status === 'OK') {
                ThunkAPI.dispatch(download());
            } else {
                alert('Your session has timeout!');
            }

        })

        return response;
    }
);

export const CancelOrderItemAsync = createAsyncThunk(
    'requestDetails/CancelOrderItem',
    async (data, ThunkAPI) => {
        const response = await CancelOrderItem(data[1]);
        const resultPromise = Promise.resolve(response);
        resultPromise.then(() => {
            ThunkAPI.dispatch(GetOrderAsync(data[0]));
        })
        return response;
    }
);


export const requestDetailsSlice = createSlice({
    name: 'requestDetails',
    initialState,
    reducers: {
        initiateAction: (state, action) => {
            state.orderDetails = null;
            state.payCount = 0;
        },
        fileInfo: (state, action) => {
            state.file = action.payload;
        },
        downloadFile: (state, action) => {
            var link = document.createElement('a');
            link.download = state.file.name;
            link.href = state.file.url;
            document.body.appendChild(link);
            link.click();
        },
    },
    extraReducers: (builder) => {

        builder.addCase(GetOrderAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(GetOrderAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(GetOrderAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            state.orderDetails = action.payload && action.payload.Orders && action.payload.Orders.length > 0 ? action.payload.Orders[0] : null;
            if (state.orderDetails && state.orderDetails.Invoices) {
                state.payCount = state.orderDetails.Invoices && state.orderDetails.Invoices.length > 0 ? (state.orderDetails.Invoices.filter((data) => (data.StatusCode === 'PP' && !data.IsExpired))) : []

                state.payCount = state.payCount ? state.payCount.length : 0;
            } else {
                state.payCount = 0;
            }


            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage)
            }
        });
        builder.addCase(checkSessionAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(checkSessionAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(checkSessionAsync.fulfilled, (state, action) => {
            state.status = 'idle';
        });
        builder.addCase(checkLoginAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(checkLoginAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(checkLoginAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                window.location.href = "./login";
            }
        });

        builder.addCase(CancelOrderItemAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(CancelOrderItemAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(CancelOrderItemAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage)
            }

        });
    }
});

export const { fileInfo, downloadFile, initiateAction } = requestDetailsSlice.actions;
export const pageDetails = (state) => state.requestDetails.orderDetails;
export const pagesState = (state) => state.requestDetails;
export const mySession = (state) => state.Session.mySession;

export const download = () => (dispatch, getState) => {
    dispatch(downloadFile());
};

export default requestDetailsSlice.reducer;
